<button class="filter-button"
    finderLinkId
    [attr.id]="id"
    [ngClass]="{'selected': selected, 'shrink': shrink}"
    [attr.aria-label]="ariaLabel"
    [attr.aria-pressed]="selected">
        <finder-font-icon class="icon" [name]="icon" size="inherit"></finder-font-icon>
        <ng-content></ng-content>
</button>
